import { type LucideIcon, Signal, SignalHigh, SignalLow, SignalMedium } from 'lucide-react'

import { RiskLevel } from '@/gen/inventory/v1/risk_pb'

export const RISK_LEVEL_MAP = {
  [RiskLevel.CRITICAL]: { variant: 'danger', text: 'C', icon: Signal },
  [RiskLevel.HIGH]: { variant: 'warning' as const, text: 'H', icon: SignalHigh },
  [RiskLevel.MEDIUM]: { variant: 'attention' as const, text: 'M', icon: SignalMedium },
  [RiskLevel.LOW]: { variant: 'neutral' as const, text: 'L', icon: SignalLow },
} as Partial<
  Record<
    RiskLevel,
    { variant: 'danger' | 'warning' | 'attention' | 'neutral'; text: string; icon: LucideIcon }
  >
>
